
export const getLoadingErrorState = (initialData) => ({
  data: initialData,
  error: null,
  loading: false,
});
